<template>
      <div class="pay_wrapper_box">
        <div class="pay_title">资源套餐</div>

        <div v-if="orderConfirmWrapper.purchaseType == 3" class="my-table" style="width: 68vw; ">
          <div>
            <div class="table-header">
              <span class="table-cell" style="margin-left: 2vw; width: 8vw;">套餐名称</span>
              <span class="table-cell" style="width: 17vw;">套餐规格</span>
              <span class="table-cell" style="width: 6vw;">购买时长</span>
              <span class="table-cell" style="width: 7vw;">License数量</span>
              <span class="table-cell" style="width: 9vw;">月单价（元/License）</span>
              <span class="table-cell" style="width: 9vw;">月差价（元/License）</span>
              <span class="table-cell" style="width: 8vw;">总价（元）</span>
            </div>
            <hr style="margin-bottom: 0px; margin-top: 0px;">
          </div>
          <div>
            <div class="table-row">
              <span class="table-cell" style="margin-left: 2vw; width: 8vw;">{{orderConfirmWrapper.name}}</span>
              <span class="table-cell" style="width: 17vw; color: #666;">{{orderConfirmWrapper.spec}}</span>
              <span class="table-cell" style="width: 6vw;">{{orderConfirmWrapper.duration}}{{orderConfirmWrapper.unit}}</span>
              <span class="table-cell" style="width: 7vw;">{{orderConfirmWrapper.licenseCount}}</span>
              <span class="table-cell" style="width: 9vw; color: #EF6234; ">{{formattedPrice(orderConfirmWrapper.unitPrice/100)}}</span>
              <span class="table-cell" style="width: 9vw; color: #EF6234; ">{{formattedPrice(orderConfirmWrapper.gapUnitPrice/100)}}</span>
              <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">
                  {{formattedPrice(orderConfirmWrapper.settlementAmount/100)}}
                </span>
            </div>
            <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">
          </div>
        </div>
        <div v-else class="my-table" style="width: 61vw; ">
          <div>
            <div class="table-header">
              <span class="table-cell" style="margin-left: 2vw; width: 8vw;">套餐名称</span>
              <span class="table-cell" style="width: 17vw;">套餐规格</span>
              <span class="table-cell" style="width: 7vw;">购买时长</span>
              <span class="table-cell" style="width: 8vw;">License数量</span>
              <span class="table-cell" style="width: 9vw;">月单价（元/License）</span>
              <span class="table-cell" style="width: 8vw;">总价（元）</span>
            </div>
            <hr style="margin-bottom: 0px; margin-top: 0px;">
          </div>
          <div>
            <div class="table-row">
              <span class="table-cell" style="margin-left: 2vw; width: 8vw;">{{orderConfirmWrapper.name}}</span>
              <span class="table-cell" style="width: 17vw; color: #666;">{{orderConfirmWrapper.spec}}</span>
              <span class="table-cell" style="width: 7vw;">{{orderConfirmWrapper.duration}}{{orderConfirmWrapper.unit}}</span>
              <span class="table-cell" style="width: 8vw;">{{orderConfirmWrapper.licenseCount}}</span>
              <span class="table-cell" style="width: 9vw; color: #EF6234; ">{{formattedPrice(orderConfirmWrapper.unitPrice/100)}}</span>
              <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">
                  {{formattedPrice(orderConfirmWrapper.settlementAmount/100)}}
                </span>
            </div>
            <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">
          </div>
        </div>

<!--        <div v-if="orderConfirmWrapper.purchaseType == 3" class="my-table" style="width: 65vw; ">-->
<!--          <div>-->
<!--            <div class="table-header">-->
<!--              <span class="table-cell" style="margin-left: 2vw; width: 9vw;">Token数量（万个）</span>-->
<!--              <span class="table-cell" style="width: 9vw;">访问并发（QPS/s）</span>-->
<!--              <span class="table-cell" style="width: 7vw;">License数量</span>-->
<!--              <span class="table-cell" style="width: 10vw;">到期时间</span>-->
<!--              <span class="table-cell" style="width: 7vw;">剩余有效月数</span>-->
<!--              <span class="table-cell" style="width: 10vw;">差价（元/License/月）</span>-->
<!--              <span class="table-cell" style="width: 8vw;">总差价（元）</span>-->
<!--            </div>-->
<!--            <hr style="margin-bottom: 0px; margin-top: 0px;">-->
<!--          </div>-->
<!--          <div>-->
<!--            <div class="table-row">-->
<!--              <span class="table-cell" style="margin-left: 2vw; width: 9vw;">{{orderConfirmWrapper.tokenNumber}}</span>-->
<!--              <span class="table-cell" style="width: 9vw; color: #666;">{{orderConfirmWrapper.qps}}</span>-->
<!--              <span class="table-cell" style="width: 7vw;">{{orderConfirmWrapper.licenseCount}}</span>-->
<!--              <span class="table-cell" style="width: 10vw;">{{orderConfirmWrapper.lastExpireTime}}</span>-->
<!--              <span class="table-cell" style="width: 7vw;">{{orderConfirmWrapper.remainMonths}}</span>-->
<!--              <span class="table-cell" style="width: 10vw; color: #EF6234; ">{{formattedPrice(orderConfirmWrapper.unitPrice/100)}}</span>-->
<!--              <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">-->
<!--                  {{formattedPrice(orderConfirmWrapper.settlementAmount/100)}}-->
<!--                </span>-->
<!--            </div>-->
<!--            <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">-->
<!--          </div>-->

<!--          <br>-->
<!--          <div style="font-size: 12px; color: #999; line-height: 12px;">-->
<!--            <div>-->
<!--              【升级前规格与资费】Token数量：{{orderConfirmWrapper.lastTokenNumber}}万个,-->
<!--          QPS：{{orderConfirmWrapper.lastQps}}/s,-->
<!--          License数量：{{orderConfirmWrapper.licenseCount}}个,-->
<!--          月单价：{{formattedPrice(orderConfirmWrapper.lastUnitPrice/orderConfirmWrapper.lastDuration/100)}}元/License-->
<!--            </div>-->
<!--            <br>-->
<!--            <div>-->
<!--              【升级后规格与资费】Token数量：{{orderConfirmWrapper.tokenNumber}}万个,-->
<!--          QPS：{{orderConfirmWrapper.qps}}/s,-->
<!--          License数量：{{orderConfirmWrapper.licenseCount}}个,-->
<!--          月单价：{{formattedPrice(orderConfirmWrapper.upgradeUnitPrice/orderConfirmWrapper.lastDuration/100)}}元/License-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div v-else class="my-table" style="width: 60vw; ">-->
<!--          <div>-->
<!--            <div class="table-header">-->
<!--              <span class="table-cell" style="margin-left: 2vw; width: 9vw;">Token数量（万个）</span>-->
<!--              <span class="table-cell" style="width: 9vw;">访问并发（QPS/s）</span>-->
<!--              <span class="table-cell" style="width: 7vw;">有效时长</span>-->
<!--              <span class="table-cell" style="width: 7vw;">到期时间</span>-->
<!--              <span class="table-cell" style="width: 8vw;">License数量</span>-->
<!--              <span class="table-cell" style="width: 8vw;">单价（元/License）</span>-->
<!--              <span class="table-cell" style="width: 8vw;">总价（元）</span>-->
<!--            </div>-->
<!--            <hr style="margin-bottom: 0px; margin-top: 0px;">-->
<!--          </div>-->
<!--          <div>-->
<!--            <div class="table-row">-->
<!--              <span class="table-cell" style="margin-left: 2vw; width: 9vw;">{{orderConfirmWrapper.tokenNumber}}</span>-->
<!--              <span class="table-cell" style="width: 9vw; color: #666;">{{orderConfirmWrapper.qps}}</span>-->
<!--              <span class="table-cell" style="width: 7vw;">{{orderConfirmWrapper.duration}}个月</span>-->
<!--              <span class="table-cell" style="width: 7vw;">{{expireDate(orderConfirmWrapper.duration)}}</span>-->
<!--              <span class="table-cell" style="width: 8vw;">{{orderConfirmWrapper.licenseCount}}</span>-->
<!--              <span class="table-cell" style="width: 8vw; color: #EF6234; ">{{formattedPrice(orderConfirmWrapper.unitPrice/100)}}</span>-->
<!--              <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">-->
<!--                  {{formattedPrice(orderConfirmWrapper.settlementAmount/100)}}-->
<!--                </span>-->
<!--            </div>-->
<!--            <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">-->
<!--          </div>-->
<!--        </div>-->

      </div>

</template>

<script>
import {mapState, mapGetters} from 'vuex'
import {
  dateFormatter
} from '@/common/utils.js'

export default {
  name: 'OrderPayInfo',
  data() {
    return {
    }
  },

  methods: {

    expireDate(month) {
      let date = new Date(this.orderConfirmWrapper.lastExpireTime)
      date.setMonth(date.getMonth() + month)
      return dateFormatter(date)
    },

    formattedPrice (price) {
      return parseFloat(price).toFixed(2); // 保留两位小数
    }

  },

  computed: {
    ...mapState(['orderConfirmWrapper']),
    ...mapGetters(['isLogin']),

  }
}
</script>

<style scoped>

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .pay_wrapper_box {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .pay_title {
    font-size: 18px;
    color: #333;
    line-height: 24px;
    font-weight: bold;
  }

  .pay_box {
    width: 160px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 8px;
    border: 1px solid #FF9933;
    display: flex;
    flex-direction: row;
  }

  .pay_tips {
    font-size: 12px;
    color: #999;
  }

  .pay_button_wrapper {
    display: flex;
    justify-content: right;
    margin-bottom: 140px;
  }

  .pay_button {
    margin-left: 30px;
    height: 40px;
  }

  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #99CCFF !important;
    cursor:pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderPayInfo.vue